import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';
import { LanguageService } from './language.service';
import { SesionService } from './sesion.service';


@Injectable()
export class LanguageInterceptorService implements HttpInterceptor {

  constructor(private sesion: SesionService) { }


  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const language = this.sesion.idioma$.getValue();
    if (language) {
      request = this.addLanguageHeader(request, language);
    }

    return next.handle(request);
  }
  private addLanguageHeader(request: HttpRequest<any>, language: string): HttpRequest<any> {
    const country = this.sesion.idioma$.getValue() === 'en' ? 'US' : language.toUpperCase();
    return request.clone({
      setHeaders: {
        'Accept-Language': this.sesion.idioma$.getValue() + '-' + country
      }
    });
  }
}
